import {Backbone} from 'Vertebrae';
import {SearchFilter} from '../model/searchFilter';

export const SearchFilters = Backbone.Collection.extend({
    _name: 'SearchFilters',
    model: SearchFilter,
    url: '/search/filters.json',
    convertToQueryObject: function() {
        var data = {};

        // convert every filter into a key:value pair to pass to the search action
        this.each(function(f) {
            var key = f.get('key');
            var value = f.get('value');

            if (!value) {
                return;
            }

            if (value && typeof value === 'object' && value.hasOwnProperty('label')) {
                if (key === 'location' && value.label && value.pastLocations) {
                    data['locationIncludePast'] = true;
                }
                // Handle custom objects.
                value = value.label
            }

            if (Array.isArray(data[key])) {
                data[key] = [...(data[key] || []), ...(value || [])];
            } else {
                data[key] = value;
            }
        });
        return data;
    },
    resetFilters: function() {
      this.each((f) => {
          const isArr = f.get('isArrayType');
          f.set('value', isArr ? [] : null);
      })
    },
    loadFromQueryObject: function(query) {
        var that = this;

        if (query.price_min || query.price_max) {
            query.price = {
                min: query.price_min,
                max: query.price_max,
            };
            delete query.price_min;
            delete query.price_max;
        }

        const pastLocations = !!query.locationIncludePast;
        delete query.locationIncludePast;

        // for each key, value pair in our query object
        _.each(query, function(value, key) {
            // get the filter object with this key
            var f = that.findWhere({'key': key});

            // if we have a matching filter
            if (f && value !== 'false') {
                // update its value accordingly
                if (f.get('isArrayType') && !Array.isArray(value)) {
                    value = [value];
                } else if (f.get('type') === 'location') {
                    value = {
                        label: value,
                        pastLocations
                    }
                } else if (typeof value === 'object') {
                    value = value.value;
                }

                f.set('value', value);
            }
        });
    },
});
